import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

var TABLE_TOOLTIP_DEFAULT_Y_OFFSET = 33;
var TABLE_TOOLTIP_DEFAULT_X_OFFSET = 7;
var getAvailableRight = function getAvailableRight(state) {
  return window.innerWidth - (state.rects.reference.x + state.rects.popper.width + 2);
};
export var getDefaultTooltipPopperState = function getDefaultTooltipPopperState(state) {
  var newState = _objectSpread({}, state);
  if (newState.modifiersData.popperOffsets) {
    if (newState.placement.includes('bottom')) {
      newState.modifiersData.popperOffsets.y -= TABLE_TOOLTIP_DEFAULT_Y_OFFSET;
    } else {
      // it moved the popper to the top, recenter it
      newState.modifiersData.popperOffsets.y += TABLE_TOOLTIP_DEFAULT_Y_OFFSET;
    }
    if (newState.placement.includes('start')) {
      var xOffset = Math.min(getAvailableRight(newState), TABLE_TOOLTIP_DEFAULT_X_OFFSET);
      newState.modifiersData.popperOffsets.x += xOffset;
    }
  }
  return newState;
};
export var getStatusIconTooltipPopperState = function getStatusIconTooltipPopperState(state) {
  var newState = _objectSpread({}, state);
  if (newState.modifiersData.popperOffsets) {
    if (newState.placement.includes('bottom')) {
      newState.modifiersData.popperOffsets.y -= TABLE_TOOLTIP_DEFAULT_Y_OFFSET;
    } else {
      // it moved the popper to the top, recenter it
      newState.modifiersData.popperOffsets.y += TABLE_TOOLTIP_DEFAULT_Y_OFFSET;
    }
    if (newState.placement.includes('start')) {
      var defaultMinXOffset = state.elements.reference.querySelector('.EmbersStatusIcon') ? 39 : TABLE_TOOLTIP_DEFAULT_X_OFFSET;
      var xOffset = Math.min(getAvailableRight(newState), defaultMinXOffset);
      newState.modifiersData.popperOffsets.x += xOffset;
    } else {
      newState.modifiersData.popperOffsets.x += state.rects.reference.width;
    }
  }
  return newState;
};
export var getLinkCellTooltipPopperState = function getLinkCellTooltipPopperState(state) {
  var newState = _objectSpread({}, state);
  if (state.modifiersData.popperOffsets) {
    if (state.placement.includes('bottom')) {
      state.modifiersData.popperOffsets.y -= 46;
    } else {
      // it moved the popper to the top, recenter it
      state.modifiersData.popperOffsets.y += 46;
    }
    if (state.placement.includes('start')) {
      var xOffset = Math.min(getAvailableRight(newState), TABLE_TOOLTIP_DEFAULT_X_OFFSET);
      state.modifiersData.popperOffsets.x += xOffset;
    }
  }
  return newState;
};